import React from 'react';
import { Box, IconButton, MenuItem, TextField, Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';
import FormDialog from '../../../../../components/Dialog/FormDialog';
import { CustomButton } from '../../../../../components/Button/Button';
import { useEditFieldDialog } from './hooks/useEditFieldDialog';

const EditFieldDialog = ({ open, onClose, field, fieldTypes, onSubmit, isLoading = false }) => {
  const {
    name,
    type,
    options,
    isOptionType,
    setName,
    handleOptionChange,
    handleDeleteOption,
    handleAddOption,
    handleTypeChange,
    handleSubmit,
  } = useEditFieldDialog({ field, onSubmit });

  return (
    <FormDialog
      open={open}
      handleClose={onClose}
      title="Edit Field"
      fullWidth={true}
      className="edit-field-dialog"
    >
      <Box className="edit-field-dialog-body">
        <Box className="edit-field-dialog-section">
          <Typography className="edit-field-dialog-label">
            Name <span>*</span>
          </Typography>
          <TextField
            fullWidth
            value={name}
            onChange={(event) => setName(event.target.value)}
            className="edit-field-dialog-input"
            inputProps={{ maxLength: 25 }}
          />
        </Box>

        <Box className="edit-field-dialog-section">
          <Typography className="edit-field-dialog-label">
            Type <span>*</span>
          </Typography>
          <TextField
            select
            fullWidth
            value={type}
            onChange={handleTypeChange}
            className="edit-field-dialog-input"
            disabled
          >
            {fieldTypes
              .filter((option) => option.value)
              .map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
          </TextField>
        </Box>

        {isOptionType && (
          <Box className="edit-field-dialog-section">
            <Typography className="edit-field-dialog-options-title">
              Options
            </Typography>
            <Box className="edit-field-dialog-options">
              {options.map((option, index) => (
                <Box key={`${field?.custom_field_id || 'field'}-option-${index}`} className="edit-field-dialog-option-row">
                  <TextField
                    fullWidth
                    value={option}
                    onChange={(event) => handleOptionChange(index, event.target.value)}
                    className="edit-field-dialog-input"
                    inputProps={{ maxLength: 25 }}
                  />
                  <IconButton
                    className="edit-field-dialog-delete-btn"
                    onClick={() => handleDeleteOption(index)}
                    disabled={options.length === 1}
                  >
                    <DeleteOutlineIcon />
                  </IconButton>
                </Box>
              ))}
            </Box>

            <CustomButton
              variant="outlined"
              onClick={handleAddOption}
              className="edit-field-dialog-add-option"
            >
              <AddIcon fontSize="small" />
              Add Option
            </CustomButton>
          </Box>
        )}

        <Box className="edit-field-dialog-actions">
          <CustomButton
            variant="outlined"
            onClick={onClose}
            className="edit-field-dialog-cancel-btn"
            disabled={isLoading}
          >
            Cancel
          </CustomButton>
          <CustomButton
            variant="contained"
            onClick={handleSubmit}
            className="edit-field-dialog-update-btn"
            disabled={!name.trim() || !type || isLoading}
          >
            {isLoading ? 'Updating...' : 'Update'}
          </CustomButton>
        </Box>
      </Box>
    </FormDialog>
  );
};

export default EditFieldDialog;
